import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../store/themeSlice";
import { FaSun, FaMoon } from "react-icons/fa";

const ThemeToggle = () => {
  const theme = useSelector((state) => state.theme.theme);
  const dispatch = useDispatch();

  React.useEffect(() => {
    // Apply the theme to the <html> element
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  return (
    <div className="md:flex hidden items-center fixed top-6 right-4 z-50">
      <button
        aria-label="Toggle Theme button"
        onClick={() => dispatch(toggleTheme())}
        className={`relative w-16 h-8 flex items-center rounded-full p-1 shadow-lg focus:outline-none transition-all duration-500 hover:shadow-xl ${
          theme === "dark"
            ? "bg-gradient-to-r from-blue-900 to-purple-900 hover:shadow-purple-500/50"
            : "bg-gradient-to-r from-yellow-400 to-orange-400 hover:shadow-yellow-500/50"
        }`}
      >
        <div
          className={`w-6 h-6 rounded-full bg-white shadow-md flex items-center justify-center transform transition-all duration-500 ${
            theme === "dark" ? "translate-x-8" : "translate-x-0"
          }`}
        >
          {theme === "dark" ? (
            <FaMoon className="text-purple-900" />
          ) : (
            <FaSun className="text-yellow-500" />
          )}
        </div>
      </button>
    </div>
  );
};

export default ThemeToggle;
